import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ProtectedRoute, AdminRoute } from "@/components/Guards";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import TrackOrder from "@/pages/TrackOrder";
import Customize from "@/pages/Customize";
import Auth, { ForgotPassword, ResetPassword } from "@/pages/Auth";
import Account from "@/pages/Account";
import Wishlist from "@/pages/Wishlist";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminInventory from "@/pages/admin/Inventory";
import AdminOrders from "@/pages/admin/Orders";
import AdminCustomers from "@/pages/admin/Customers";
import AdminCoupons from "@/pages/admin/Coupons";
import AdminAnalytics from "@/pages/admin/Analytics";
import AdminCustomOrders from "@/pages/admin/CustomOrders";

function StoreLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-ink">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

const S = (el) => <StoreLayout>{el}</StoreLayout>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            <Route path="/" element={S(<Home />)} />
            <Route path="/shop" element={S(<Shop />)} />
            <Route path="/product/:slug" element={S(<ProductDetail />)} />
            <Route path="/cart" element={S(<Cart />)} />
            <Route path="/checkout" element={S(<Checkout />)} />
            <Route path="/order-success/:id" element={S(<OrderSuccess />)} />
            <Route path="/track" element={S(<TrackOrder />)} />
            <Route path="/customize" element={S(<Customize />)} />
            <Route path="/auth" element={S(<Auth />)} />
            <Route path="/forgot-password" element={S(<ForgotPassword />)} />
            <Route path="/reset-password/:token" element={S(<ResetPassword />)} />
            <Route path="/account" element={S(<ProtectedRoute><Account /></ProtectedRoute>)} />
            <Route path="/wishlist" element={S(<ProtectedRoute><Wishlist /></ProtectedRoute>)} />
            <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="inventory" element={<AdminInventory />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="custom-orders" element={<AdminCustomOrders />} />
              <Route path="customers" element={<AdminCustomers />} />
              <Route path="coupons" element={<AdminCoupons />} />
              <Route path="analytics" element={<AdminAnalytics />} />
            </Route>
          </Routes>
          <Toaster theme="dark" position="bottom-right" toastOptions={{
            style: { background: "#121212", border: "1px solid #D4AF37", color: "#F5F5F0" },
          }} />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
